import React from 'react';
import { Card } from '@mui/material';
import { createClasses } from '@kp/react-ui';
import * as Icons from '@mui/icons-material';
import { LayoutSimple } from '../LayoutSimple';
import { Loading } from '../Loading';
import { Color } from '../../constants/Colors';

const classes = createClasses({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 0,
    zIndex: 9999,
  },
  errorWrapper: {
    padding: '5px',
  },
  errorBox: {
    padding: '15px',
    paddingRight: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Color.error,
    color: 'white',
  },
  errorIcon: {
    marginRight: '15px',
    color: 'white',
  },
});

interface GlobalLoadingProps {
  error?: Error | null;
}

export const GlobalLoading: React.FC<GlobalLoadingProps> = ({ error }) => {
  return (
    <div className={classes.container}>
      <LayoutSimple>
        {error ? (
          <Card className={classes.errorWrapper}>
            <div className={classes.errorBox}>
              <Icons.Error className={classes.errorIcon} />
              {error.message}
            </div>
          </Card>
        ) : (
          <Loading />
        )}
      </LayoutSimple>
    </div>
  );
};
